import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { UsuarioService } from '../../../../providers/usuario.service';
import { Usuario, TipoUsuario } from '../../../../interfaces/usuario';
import { Telefono } from '../../../../components/telefono/telefono.component';

@Component({
  selector: 'app-estado-usuario-dialog',
  templateUrl: './estado-usuario-dialog.component.html',
  styleUrls: ['./estado-usuario-dialog.component.scss']
})
export class EstadoUsuarioDialog implements OnInit {
  error: string = '';
  cargando: boolean = true;
  usuario: Usuario;

  constructor(
    public dialogCompletar: MatDialogRef<EstadoUsuarioDialog>,
    private usuarioService: UsuarioService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.usuario = new Usuario();

    this.cargando = true;
    this.usuarioService.getUsuarios(
      {
        page: null,
        pageSize: null
      },
      {
        sort: null,
        order: null
      },
      {
        IdUsuario: this.data.IdUsuario
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data) {
          var usuario = respuesta.data.usuarios[0];
          if (usuario) {
            this.usuario = new Usuario(
              usuario.id,
              usuario.usuario,
              usuario.email,
              <TipoUsuario>{
                id: usuario.tipoUsuario.id,
                descripcion: usuario.tipoUsuario.descripcion
              },
              null,
              usuario.nombre,
              usuario.apellido,
              new Telefono(usuario.telefono.pais, usuario.telefono.area, usuario.telefono.numero),
              +usuario.estado,
              usuario.puesto,
              !!+usuario.editable,
              !!+usuario.eliminable
            );
          } else {
            this.error = "Es posible que ya no exista en la base de datos";
          }
        }

        this.cargando = false;
      },
      () => {
        this.cargando = false;
      }
    );
  }

  onCancelar(): void {
    this.dialogCompletar.close();
  }

  onCompletar(): void {
    this.error = '';

    try { // cacheo de errores antes de llamar al servidor
      this.cargando = true;

      if (this.usuario.estado != 1) {
        this.usuarioService.setUsuarioActivo(
          this.usuario
        ).subscribe(
          respuesta => {
            if (respuesta.estado == 1) {
              this.snackBar.open(respuesta.mensaje, 'OK', { duration: 2750 });
              this.dialogCompletar.close(respuesta);
            } else {
              this.error = respuesta.mensaje;
            }

            this.cargando = false;
          },
          error => {
            this.cargando = false;
            this.error = error;
          }
        );
      } else {
        this.usuarioService.setUsuarioInactivo(
          this.usuario
        ).subscribe(
          respuesta => {
            if (respuesta.estado == 1) {
              this.snackBar.open(respuesta.mensaje, 'OK', { duration: 2750 });
              this.dialogCompletar.close(respuesta);
            } else {
              this.error = respuesta.mensaje;
            }

            this.cargando = false;
          },
          error => {
            this.cargando = false;
            this.error = error;
          }
        );
      }
    } catch (error) {
      this.error = error;
      this.cargando = false;
    }

  }
}
